import styles from "./todoList.module.css";
const Todo = ({ todo }) => {
  return (
    <div className={styles.container}>
    <div className={styles.todoContainer} key={todo.id}>
     

      <div>{todo.user_tag_id.label}</div>
      <div>{todo.price}</div>
      <div>{todo.text}</div>
      
      <div>
        
      </div>
    </div>
  </div>
  );
};

export default Todo;
